import { Link } from '@rulebooks/evidend-titan';
import { useDownloadFileLazyQuery } from 'generated/gql';
import React from 'react';

interface IDownloadFileLink {
  children: React.ReactNode;
  documentId: string;
}

export const DownloadFileLink = ({ children, documentId }: IDownloadFileLink) => {
  const [getDownloadLink] = useDownloadFileLazyQuery({
    fetchPolicy: 'no-cache',
    variables: {
      documentId,
    },
    onCompleted: ({ downloadFile }) => {
      window.open(downloadFile.toString(), '_blank');
    },
  });

  return <Link onClick={() => getDownloadLink()}>{children}</Link>;
};
